// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"98a3522d","202":"f100626a","274":"b4a8ac24","488":"71dfd8b1","794":"88958650"}[chunkId] + ".css";
};